/* ========================================
   GLOBAL PARTICLES - Colorful pastel confetti
   Soft shapes falling with gentle sway
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {
  const canvas = document.getElementById('global-particles');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  let particles = [];
  let mouseX = -1000;
  let mouseY = -1000;
  let isTouch = window.matchMedia('(pointer: coarse)').matches;

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  const palette = [
    'rgba(255, 214, 186, 0.75)',
    'rgba(181, 234, 215, 0.75)',
    'rgba(199, 206, 234, 0.75)',
    'rgba(255, 170, 165, 0.75)',
    'rgba(255, 209, 220, 0.75)',
    'rgba(162, 210, 255, 0.75)',
    'rgba(255, 245, 186, 0.75)',
    'rgba(255, 223, 211, 0.75)',
  ];

  const shapes = ['circle', 'circle', 'circle', 'soft-rect', 'heart'];

  function drawShape(ctx, shape, x, y, size, color) {
    ctx.fillStyle = color;
    ctx.beginPath();
    if (shape === 'circle') {
      ctx.arc(x, y, size, 0, Math.PI * 2);
      ctx.fill();
    } else if (shape === 'soft-rect') {
      const r = size;
      ctx.moveTo(x - r, y - r * 0.6);
      ctx.lineTo(x + r, y - r * 0.6);
      ctx.quadraticCurveTo(x + r * 1.2, y, x + r, y + r * 0.6);
      ctx.lineTo(x - r, y + r * 0.6);
      ctx.quadraticCurveTo(x - r * 1.2, y, x - r, y - r * 0.6);
      ctx.fill();
    } else if (shape === 'heart') {
      const s = size * 0.8;
      ctx.moveTo(x, y + s * 0.3);
      ctx.bezierCurveTo(x, y, x - s, y - s * 0.5, x - s, y - s * 0.1);
      ctx.bezierCurveTo(x - s, y + s * 0.3, x, y + s * 0.7, x, y + s);
      ctx.bezierCurveTo(x, y + s * 0.7, x + s, y + s * 0.3, x + s, y - s * 0.1);
      ctx.bezierCurveTo(x + s, y - s * 0.5, x, y, x, y + s * 0.3);
      ctx.fill();
    }
  }

  class PastelParticle {
    constructor() {
      this.reset(true);
    }

    reset(randomY = false) {
      this.x = Math.random() * canvas.width;
      this.y = randomY ? Math.random() * canvas.height : -30;
      this.size = Math.random() * 10 + 4;
      this.speedY = Math.random() * 1.8 + 0.6;
      this.speedX = (Math.random() - 0.5) * 1.0;
      this.color = palette[Math.floor(Math.random() * palette.length)];
      this.shape = shapes[Math.floor(Math.random() * shapes.length)];
      this.rotation = Math.random() * Math.PI * 2;
      this.rotationSpeed = (Math.random() - 0.5) * 0.03;
      this.sway = Math.random() * Math.PI * 2;
      this.swaySpeed = Math.random() * 0.018 + 0.006;
      this.opacity = Math.random() * 0.35 + 0.55;
    }

    update() {
      this.y += this.speedY;
      this.x += this.speedX + Math.sin(this.sway) * 0.25;
      this.sway += this.swaySpeed;
      this.rotation += this.rotationSpeed;

      if (!isTouch) {
        const dx = this.x - mouseX;
        const dy = this.y - mouseY;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 160) {
          const force = (160 - dist) / 160;
          this.x += dx * force * 0.05;
          this.y += dy * force * 0.05;
        }
      }

      if (this.y > canvas.height + 30) {
        this.reset();
      }
      if (this.x > canvas.width + 30) this.x = -30;
      if (this.x < -30) this.x = canvas.width + 30;
    }

    draw() {
      ctx.save();
      ctx.globalAlpha = this.opacity;
      ctx.translate(this.x, this.y);
      ctx.rotate(this.rotation);
      drawShape(ctx, this.shape, 0, 0, this.size, this.color);
      ctx.restore();
    }
  }

  const count = isTouch ? 140 : 400;
  for (let i = 0; i < count; i++) {
    particles.push(new PastelParticle());
  }

  if (!isTouch) {
    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    }, { passive: true });
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles.forEach(p => { p.update(); p.draw(); });
    requestAnimationFrame(animate);
  }
  animate();
});
